import { Particle } from "../engine/anims/Particle";
import { Point } from "../engine/space/bounds";
import { DMap } from "../lib/dMap/dMap";
import { RNGGenerator } from "../lib/rng";
import { SparseMap } from "../lib/sparseMap";
import { Target } from "./abilities/Target";
import { Actor, ActorBreed, Piece } from "./actors/Actor";
import { Spell } from "./actors/Spell";
import { LookParticle } from "./anims/particles/LookParticle";
import { Item } from "./items/Item";

import { BasicMap } from "./map/BasicMap";

export const MAP_WIDTH = 40;
export const MAP_HEIGHT = 28;
export const MAP_DEPTH = 10;
export const buildState = (seed?: number) => {
  const seedRng = new RNGGenerator(seed || Date.now());
  const level = new BasicMap(MAP_WIDTH, MAP_HEIGHT, seedRng.getGenerator());

  return {
    seedRng,
    current: level,
    actors: new SparseMap<number, Actor>(),
    pieces: new SparseMap<number, Piece>(),
    items: new SparseMap<number, Item>(),
    gibs: new SparseMap<number, Particle<any>>(),
    particles: new SparseMap<number, Particle<any>>(),

    //Player Specific Props
    player: new Actor(-1, new ActorBreed("", {}), 0, 0),
    xp: 1,
    freeEntry: false,
    noWordTriggers: false,

    //AI & Navigaiton
    dMapPlayer: null as DMap | null,

    //UI Properties
    actionPending: false,
    focus: null as LookParticle<any> | null,
    focusDirection: { x: 1, y: 0 } as Point,
    focusHighlights: [] as Particle<any>[],
    letters: [] as Piece[],

    selectedSpell: null as Spell | null | undefined,
    selectedItem: null as Item | null | undefined,

    target: null as null | Target,
    targetCallback: null as null | ((pos?: Point) => void),

    wandSorted: true,
    victory: false,
  };
};

export type GameState = ReturnType<typeof buildState>;
